import { Component, Inject, Input, OnDestroy } from '@angular/core';

import { BaseComponent } from '@ridango/core';
import Env, { JourneyPlannerFilterItemValueSettings } from '@ridango/core/env';
import { FormGroup } from '@angular/forms';
import { ApplicationFacade } from '@ridango/components';

import { TransportMode, queryParameter } from '@ridango/components/lib/open-trip-planner/open-trip-planner.model';

@Component({
    selector: 'rwidget-journey-planner-filter-chips',
    templateUrl: './journey-planner-filter-chips.component.html',
    styleUrls: ['./journey-planner-filter-chips.component.scss']
})
export class JourneyPlannerFilterChipsComponent extends BaseComponent implements OnDestroy {
    @Input() values: Array<JourneyPlannerFilterItemValueSettings>;
    @Input() formGroup: FormGroup;
    @Input() formItem: string;
    @Input() multiple: boolean;

    assetsPath$ = this.applicationFacade.assetsPath$;
    public transportMode = TransportMode;
    public queryParameter = queryParameter;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade
    ) {
        super();
    }

    itemClick(event, value) {
        const formValue = this.formGroup.get(this.formItem).value;

        if (formValue.length === 1 && formValue[0] === value.VALUE) {
            event.stopPropagation();
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
